import {createSlice, createAsyncThunk} from '@reduxjs/toolkit';
import helper from '../../../utilities/helper'
import _ from 'lodash';
import { buildUrl } from '../../../utilities/StringHelpers/StringHelpers';
import { getImageProps } from 'app/utilities/ImageProps';
import { getSubscribersByProductAsync }  from './EquipmentMainAsyncThunk';

const initialState = {
    epiData: {},
    page:'',
    mineEquipments: [],
    mesError: '',
    firstName:''
};

const equipmentListSlice = createSlice({
  name: 'equipmentListPage',
  initialState: initialState,
  reducers: {
    resetPage: (state) => initialState,
    initPage: {
      reducer: (state, action) => {
        state.epiData = action.payload.epiData;
        state.page = action.payload.page;
      },
      prepare(action) {
        const payload = {};
        const equipmentMinePage = action.epiData;
        const contextEpi = action.context;
        const epiData = {
          itemsGuides: equipmentMinePage?.itemsGuides?.expandedValue,
          routerList: equipmentMinePage?.routerList?.expandedValue,
          questionsAndAnswersContentArea: equipmentMinePage?.questionsAndAnswersContentArea,
          productType: equipmentMinePage?.productType?.value,
          mainTitle: equipmentMinePage?.mainTitle?.value,
          imageTitle: equipmentMinePage?.imageTitle,
          imageTitleMobile: equipmentMinePage?.imageTitleMobile,
          titleButton: equipmentMinePage?.titleButton?.value,
          titleProdactsCellcom: equipmentMinePage?.titleProdactsCellcom?.value,
          nameModelProdact: equipmentMinePage.nameModelProdact?.value,

        };
        payload.epiData = epiData;
        payload.page = 'equipmentMain';
        return { payload: payload };
      },
    },
    goToPage: (state, action) => {
      state.page = action.payload;
      window.scrollTo(0, 0);
    },
    reportDWH: (state, action) => { },
  },
  extraReducers: {
      [getSubscribersByProductAsync.fulfilled]: (state, action) => {
        if (!action.payload) { return; }
        state.mineEquipments = action.payload?.Body.subscribers.flatMap(subscriber => subscriber || []);
        state.mesError = action.payload?.Header.ReturnCode;
        state.firstName= action.payload.Body.subscriberName
      }
  },
});

export const {
  reportDWH,
  goToPage,
  initPage
} = equipmentListSlice.actions;


export default equipmentListSlice.reducer;


